import { SxProps, Theme } from '@mui/material';
import { ComponentProps } from 'react';

import StructuredContent from 'components/@structured/StructuredContent';

import { ContentWrapper } from './LongformTemplate.styles';

interface Props {
  body?: ComponentProps<typeof StructuredContent>['content'];
  sx?: SxProps<Theme>;
}

const LongFormTemplate = ({ body, sx }: Props) => {
  if (!body) return null;

  return (
    <ContentWrapper sx={Array.isArray(sx) ? sx : [sx]}>
      <StructuredContent content={body} />
    </ContentWrapper>
  );
};

export default LongFormTemplate;
